module.exports = __webpack_public_path__ + "static/media/correctiv-weekly.17f1c677.svg";